import { Role } from '../types/auth';

/**
 * A qué recorridos se puede transferir una actuación básica (espejo de
 * `transferAction` en el back). Decisión 2026-07-21: solo a recorridos
 * operativos. Transferir tramo (spec 2026-10-07, T7): gestión repara
 * recorridos en revisión — un tramo pasa entre recorridos pendientes de
 * validar y su básica tiene que poder seguirle —, así que para esos roles
 * también cuentan los pendientes de validar. La tablet, como antes.
 */
export const RV_TRANSFER_TARGET_STATES = ['open', 'in-progress', 'paused'];

// Los que transfieren tramos. Sala no: no transfiere actuaciones (solo
// comunicaciones, `canRoleCreateContentInState` en el back).
export const RV_TRANSFER_REVIEW_ROLES: string[] = [
  Role.SuperAdmin,
  Role.Coex,
  Role.Capataz,
];

export const rvTransferTargetStates = (role?: string | null): string[] =>
  role && RV_TRANSFER_REVIEW_ROLES.includes(role)
    ? [...RV_TRANSFER_TARGET_STATES, 'pending-validation']
    : RV_TRANSFER_TARGET_STATES;
